import { createSlice } from "@reduxjs/toolkit";

import { type CategoryStateType } from "../interfaces/category";

const initialState: CategoryStateType = {
  isLoading: false,
  categories: [],
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategoryLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
  },
});

export const { setCategoryLoading, setCategories } = categorySlice.actions;
export default categorySlice.reducer;
